export default "__VITE_ASSET__DoVjvq5o__"